import { store } from 'src/index';

export function GetCustomAttributesStore() {
  return store.getState()['customAttributes'].values;
}
